import ReviewsAndTestimonialsContainer from './ReviewsAndTestimonialsContainer';

const longContent =
  'Yhteistyö sujui erinomaisesti alusta loppuun. Projekti aikataulutettiin selkeästi ja kommunikaatio oli koko ajan avointa ja nopeaa. ' +
  'Saimme säännöllisesti väliraportteja ja pystyimme antamaan palautetta jo työn aikana, mikä näkyi lopputuloksen laadussa. ' +
  'Tekninen osaaminen oli huippuluokkaa ja ehdotukset paransivat alkuperäistä suunnitelmaamme merkittävästi. ' +
  'Erityisesti arvostimme sitä, että haastavatkin ongelmat ratkaistiin itsenäisesti ja ratkaisut perusteltiin ymmärrettävästi. ' +
  'Lopputulos ylitti odotuksemme ja projekti valmistui etuajassa. ' +
  'Voimme lämpimästi suositella yhteistyötä kaikille, jotka etsivät luotettavaa ja ammattitaitoista kumppania vaativiin digitaalisiin projekteihin. ' +
  'Jatkamme yhteistyötä varmasti myös tulevissa hankkeissa.';

export const WithLongTestimonial = {
  component: ReviewsAndTestimonialsContainer,
  props: {
    reviews: [],
    testimonials: [
      {
        id: 't1',
        state: 'published',
        content: longContent,
        workExperienceTask: 'Verkkokaupan uudistus',
        workExperienceCustomerName: 'Esimerkki Oy',
        authorName: 'Anna Asiakas',
        authorPosition: 'Markkinointijohtaja',
      },
      {
        id: 't2',
        state: 'published',
        content: 'Lyhyt suosittelu, joka mahtuu yhdelle riville.',
        workExperienceTask: 'Logosuunnittelu',
        workExperienceCustomerName: 'Toinen Oy',
        authorName: 'Bertta Botnia',
        authorPosition: 'CEO',
      },
    ],
  },
  group: 'containers',
};
